<h2 mat-dialog-title>{{ data.title || 'Package Template' }}</h2>
<div class="edit-template-modal-container" mat-dialog-content>
  <semeris-template-form
    [ngClass]="class$ | async"
    [item]="data?.data"
    [type]="data?.type"
    [disabled]="data?.disabled"
    [hasIntegrationIdentifier]="data?.hasIntegrationIdentifier"
    [hasDisplayShortName]="data?.hasDisplayShortName"
    [assets]="data?.assets"
    [datapointFieldOptions]="datapointFieldOptions$ | async"
    [presentationType]="ruleModalConfig?.presentationType"
    [verificationType]="ruleModalConfig?.verificationType"
    [aiContribution]="ruleModalConfig?.aiContribution"
  ></semeris-template-form>

  <semeris-crud-list-item-meta [item]="data?.data">
    @if (data?.data?.integrationIdentifier; as info) {
      <span>Integration Id: {{ info }}</span>
    }
  </semeris-crud-list-item-meta>
</div>
<div class="edit-template-mat-modal-actions" mat-dialog-actions align="end">
  <button semerisButton variant="text" [mat-dialog-close]="false">Cancel</button>
  <button semerisButton variant="raised" [disabled]="data?.disabled" (click)="submit()" color="accent">Save</button>
</div>
